import { render } from "./IconCheckbox.vue?vue&type=template&id=32175a6e&scoped=true&ts=true"
import script from "./IconCheckbox.vue?vue&type=script&lang=ts"
export * from "./IconCheckbox.vue?vue&type=script&lang=ts"

import "./IconCheckbox.vue?vue&type=style&index=0&id=32175a6e&scoped=true&lang=css"

import exportComponent from "/var/www/mj-root/fe-site-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32175a6e"]])

export default __exports__